import React from "react"
import { getFront } from '../utils/api'
import Container from "./Container"
import { PageConsumer } from '../context/theme'

function renderRepeater(array){  
  return  array && (array.map((item, key) => (
      <div className={item.is_rep_images === true ? 'faq_block_with_images' + " faq_block" : "faq_block"} key={key}>
        {
          item.is_rep_images === true
          ?
            <div className="faq_block_repeater">
              <h3
                dangerouslySetInnerHTML={{__html: item.title}}
              />
              <div className="faq_rep_images">
                { item.repeater &&
                  item.repeater.map((rep_item, key) => (
                    <div className="faq_rep_images_item" key={key}>
                      <img src={rep_item.image.url} alt={rep_item.image.alt}/>
                      <span>{rep_item.description}</span>
                    </div>
                  ))
                }
              </div>
            </div>
          :
            <>
              <h3
                dangerouslySetInnerHTML={{__html: item.title}}
              />
              <div
                dangerouslySetInnerHTML={{__html: item.description}}
              />
            </>
        }
      </div>
    ))
  )
}


export default class FAQ extends React.Component{

  state = {
    frontpageObject: null
  }


  componentDidMount(){  
    getFront().then(( frontpageObject ) => {
      this.setState({
        frontpageObject
      })
    })
  }






  render(){

    let { frontpageObject } = this.state;

    return (
      <PageConsumer>

        {([currentPageObject]) =>
          ( frontpageObject && currentPageObject ) &&
            <Container
              currentPageObject = {currentPageObject}
              frontpageObject = {frontpageObject}
            >
                <div className="container faq_page">
                  <h2>{currentPageObject.acf.title}</h2>
                  <>
                    { currentPageObject && renderRepeater(currentPageObject.acf.content_repeater) }
                  </>
                </div>
            </Container>
        }

      </PageConsumer>
    )
  }
}

